<template>
  <div
    class="notification-item px-5 py-3 flex items-center text-sm"
    :class="{ 'is-viewed': isViewed, 'is-clickable': options.isClickable }"
    @click="notificationClick(options)"
  >
    <Avatar
      :url="avatarUrl"
      :icon="options.avatarIcon"
      :text="avatarText"
      :color="options.avatarColor"
    ></Avatar>
    <div class="pl-4">
      <div class="font-semibold">{{ title == '' ? options.title : title }}</div>
      <p>{{ description == '' ? options.description : description }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
// components
import Avatar from '@/components/avatar/Avatar.vue'
// composables
import { useRouter } from 'vue-router'
// vue
import { ref } from 'vue'
// dictionaries
import { getDictionaryItem, type NotificationTypeItem } from '@/dictionary'

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'Error'
  },
  avatarUrl: {
    type: String,
    default: ''
  },
  avatarText: {
    type: String,
    default: ''
  },
  isViewed: {
    type: Boolean,
    default: false
  },
  path: {
    type: String,
    default: ''
  }
})
const router = useRouter()

// Get notification type from dictionary
const notificationType = getDictionaryItem<NotificationTypeItem>(
  'notificationTypes',
  props.type
) as NotificationTypeItem

const options = ref<NotificationTypeItem & { isClickable: boolean }>({
  ...notificationType,
  path: props.path || notificationType.path || null,
  isClickable: false
})

// Determine if notification is clickable
if (
  (options.value.path != null && options.value.path.length > 0) ||
  (options.value.url != null && options.value.url.length > 0)
) {
  options.value.isClickable = true
}

/**
 * Handles notification click event
 * @param options - The notification options object
 */
function notificationClick(options: NotificationTypeItem & { isClickable: boolean }): void {
  if (options.isClickable && options.path) {
    router.push(options.path)
  }
}
</script>

<style>
.notification-item h5 {
  font-weight: 500;
}

.notification-item:hover {
  background-color: rgb(249, 249, 249);
}

.notification-item.is-clickable:hover {
  cursor: pointer;
}

.dark .notification-item:hover {
  background-color: var(--darkmode-3);
}

.notification-item.is-viewed h5 {
  font-weight: 500;
}

.notification-item.is-viewed {
  background-color: rgb(249, 249, 249);
  font-weight: 500;
}

.dark .notification-item.is-viewed {
  background-color: var(--darkmode-2);
}

.dark .notification-item.is-viewed:hover {
  background-color: var(--darkmode-3);
}
</style>
